module.exports = __webpack_public_path__ + "img/mkinetikos-3.9af18738.png";